let version = require('../package.json').version;
let apiVersion = "1.0.21"; // same as version in RageApi/package.json

const config = {
  applicationId: String(process.env.REACT_APP_APPLICATION_ID), // id to be sent to backend
  applicationIdAnkauf: String(process.env.REACT_APP_APPLICATION_ID_ANKAUF),
  deuBaEnv: String(process.env.REACT_APP_DEUBA),
  apiVersion: apiVersion, // version of the supported REST interface version
  buildId: version, // the build of our App
  scriptName: "index.js",
  calculationTimeout: 950,
  calculationTimeoutTouch: 1550,
  baseUrl: "",
  themeClasses: {
    "default": "default-design",
    "volksbank": "volksbank-design",
    "dkb": "dkb-design",
    "sparkasse": "sparkasse-design",
    "deutschebank": "deutschebank-design",
    "postbank": "postbank-design",
  },
  isEdelmetallShop: () => {
    return !!String(config.applicationId).match(/^(Rage|VNeo)Em/);
  },
  isSortenShop: () => {
    return !!String(config.applicationId).match(/^(Rage|VNeo)So/);
  },
  isKundenShop: function () {
    return !!String(config.applicationId).match(/(Rage|VNeo)(Em|So)Wl(Buy|Sell)/);
  },
  isMaShop: function () {
    return !!String(config.applicationId).match(/(Rage|VNeo)(Em|So)(Bp|Ma)(Buy|Sell)/);
  },
  isAnkaufShop: function () {
    return !!String(config.applicationId).match(/(Rage|VNeo)(Em|So)(Bp|Wl|Ma)Sell/);
  },
  isVerseNeo: function () {
    return !!String(config.applicationId).match(/VNeo/);
  },
  isDeuBa: function () {
    return !!("true" === config.deuBaEnv);
  },
  getShopConfig: (settings) => {
    if (config.isEdelmetallShop() && settings.edelmetall) {
      return settings.edelmetall;
    } else if (config.isSortenShop() && settings.sorten) {
      return settings.sorten;
    } else {
      return settings.default;
    }
  },
};

// list all used process.env variables here
let env = {
  context: {
    CONTEXT_ROOT: process.env.REACT_APP_CONTEXT_ROOT,
    CONTEXT_ROOT_SHOP_MA_BUY: process.env.REACT_APP_CONTEXT_ROOT_SHOP_MA_BUY,
    CONTEXT_ROOT_SHOP_MA_SELL: process.env.REACT_APP_CONTEXT_ROOT_SHOP_MA_SELL,
    NOBLEMETALS_SHOP_BUY: process.env.REACT_APP_NOBLEMETALS_SHOP_BUY,
    NOBLEMETALS_SHOP_SELL: process.env.REACT_APP_NOBLEMETALS_SHOP_SELL,
    CURRENCIES_SHOP_BUY: process.env.REACT_APP_CURRENCIES_SHOP_BUY,
    CURRENCIES_SHOP_SELL: process.env.REACT_APP_CURRENCIES_SHOP_SELL,
    SHOP_ROOT: process.env.REACT_APP_SHOP_ROOT || "/se-shop",
    RAGE_ROOT: process.env.REACT_APP_RAGE_ROOT || "/se-shop/rage",
    REDIRECT_BUY: process.env.REACT_APP_REDIRECT_BUY,
    REDIRECT_SELL: process.env.REACT_APP_REDIRECT_SELL
  },
  pathes: {
    images: process.env.REACT_APP_IMAGES_URL,
    info: "$RAGE_ROOT/edelmetallInfo"
  },
  rest: {
    session: process.env.REACT_APP_SESSION_PATH,
    session_ping: process.env.REACT_APP_SESSION_PING_PATH,
    basedata: process.env.REACT_APP_BASEDATA_PATH,
    masterdata: process.env.REACT_APP_MASTERDATA_PATH,
    masterdataAnkauf: process.env.REACT_APP_MASTERDATA_PATH,
    catalog: process.env.REACT_APP_KATALOG_PATH,
    order: process.env.REACT_APP_ORDER_PATH,
    mandant: process.env.REACT_APP_MANDANT_PATH,
    kunde: process.env.REACT_APP_KUNDEN_ENTRY_PATH,
    warenkorb: process.env.REACT_APP_WARENKORB_PATH,
    edelmetallKonditionen: "/edelmetall/konditionenProdukt/",
    sortenKonditionen: "/sorten/konditionenProdukt/",
    edelmetallKonditionenAbsolut: "/edelmetall/konditionenAbsolut/",
    sortenKonditionenAbsolut: "/sorten/konditionenAbsolut/",
    mandantOrderLimit: "/mandantOrderLimit/",
    orderLimitBootstrap: "/mandant/orderLimit",
    edelmetallStufen: "/edelmetall/konditionenStufen/",
    sortenStufen: "/sorten/konditionenStufen/",
    logon: "/logonClientNext",
    yesLogin: "/yes/logonUrlYes",
    yesResponseExt: "/yes/responseExt",
    orderPdf: "/order/orderPdf/",
    sendeTlsCode: "/mailversandTls/",
    logError: "/logerror/",
    deleteFile: "/mandantFile/",
    exitApp: "/exitApp",
    hinweise: "/hinweise"
  },
  servlet: {
    downloadImage: "/mandantImageDownload?mandantId=#{mandantId}&imageType=#{type}",
    logoImage: "/mandantImageUpload?mandantId=#{mandantId}&imageType=logo",
    contactImage: "/mandantImageUpload?mandantId=#{mandantId}&imageType=contact",
    orderPdf: "/orderPdfDownload?mandantId=#{mandantId}&orderId=",
    uploadFile: "/mandantFileUpload?mandantId=#{mandantId}&fileId=",
    downloadFile: "/mandantFileDownload?mandantId=#{mandantId}&fileId=",
  },
  link: {
    LINK_ADMIN_PAGE: process.env.REACT_APP_LINK_ADMIN_PAGE,
    LINK_BACK_TO_SHOP: process.env.REACT_APP_LINK_BACK_TO_SHOP,
    LINK_BACK_TO_SHOP_KUNDE: process.env.REACT_APP_LINK_BACK_TO_SHOP_KUNDE,
    LINK_DANKE: process.env.REACT_APP_LINK_DANKE,
    LINK_EMPFEHLUNG: process.env.REACT_APP_LINK_EMPFEHLUNG,
    LINK_FILIALELIEFERUNG: process.env.REACT_APP_LINK_FILIALELIEFERUNG,
    LINK_HOME_KUNDE: process.env.REACT_APP_LINK_HOME_KUNDE,
    LINK_KUNDE_LOGIN: process.env.REACT_APP_LINK_KUNDE_LOGIN,
    LINK_KUNDENDATEN_EDIT: process.env.REACT_APP_LINK_KUNDENDATEN_EDIT,
    LINK_KUNDEN_ADDRESSE_MA: process.env.REACT_APP_LINK_KUNDEN_ADDRESSE_MA,
    LINK_KUNDEN_ADDRESSE_MA_EDIT: process.env.REACT_APP_LINK_KUNDEN_ADDRESSE_MA_EDIT,
    LINK_KUNDEN_ORDER_DETAILS_MA: process.env.REACT_APP_LINK_KUNDEN_ORDER_DETAILS_MA,
    LINK_MITARBEITERLOGIN: process.env.REACT_APP_LINK_MITARBEITERLOGIN,
    LINK_MITARBEITERLOGIN_KONDITION: process.env.REACT_APP_LINK_MITARBEITERLOGIN_KONDITION,
    LINK_MITARBEITER_ADD_KUNDEN: process.env.REACT_APP_LINK_MITARBEITER_ADD_KUNDEN,
    LINK_RETRIEVE_PASSWORD: process.env.REACT_APP_LINK_RETRIEVE_PASSWORD,
    LINK_RETRIEVE_USERNAME: process.env.REACT_APP_LINK_RETRIEVE_USERNAME
  },
  string: {
    NODE_ENV: process.env.NODE_ENV,
    ANKAUF: String(process.env.REACT_APP_ANKAUF).replace(/\/{1,2}$/, ""),
    BUTTON_ORDER: "Order bestätigen",
    DEFAULT_KONTAKT_IMAGE: process.env.REACT_APP_DEFAULT_KONTAKT_IMAGE,
    HASH_ID: process.env.REACT_APP_HASH_ID,
    NOBLEMETALS_SHOP_BUY_TITLE: process.env.REACT_APP_NOBLEMETALS_SHOP_BUY_TITLE,
    NOBLEMETALS_SHOP_SELL_TITLE: process.env.REACT_APP_NOBLEMETALS_SHOP_SELL_TITLE,
    CURRENCIES_SHOP_BUY_TITLE: process.env.REACT_APP_CURRENCIES_SHOP_BUY_TITLE,
    CURRENCIES_SHOP_SELL_TITLE: process.env.REACT_APP_CURRENCIES_SHOP_SELL_TITLE,
    SHOP_ID: process.env.REACT_APP_SHOP_ID,
    SHOP_NAME: process.env.REACT_APP_SHOP_NAME,
  },
  number: {
    SESSION_TTL: process.env.REACT_APP_SESSION_TTL,
    SESSION_WARN: process.env.REACT_APP_SESSION_WARN,
    MAX_BASKET_ITEMS: 10
  },
  boolean: {
    DEBUG: process.env.NODE_DEBUG === "debug",
    KUNDEN_SHOP: process.env.REACT_APP_KUNDEN,
    MITARBEITER_SHOP: !process.env.REACT_APP_KUNDEN,
    VERSE_NEO: process.env.REACT_APP_VERSE_NEO,
    DEUBA: process.env.REACT_APP_DEUBA
  },
  Admin: {
    edelmetall: {
      basedata: "/edelmetall/katalog",
      catalog: "/edelmetall/preis",
      appId: "RageEmBpBuy",
    },
    sorten: {
      basedata: "/sorten/katalog",
      catalog: "/sorten/kurs",
      appId: "RageSoBpBuy",
    },
    // verwendete Host Schnittstellen z.Z. nur bei Auftragsverwaltung wg Unterschiede in VerSEneo und Rage+
    hostApi: ["SO279", "SO280"]
  },
  RageEmWl: {
    context: {
      CONTEXT_ROOT: `/se-shop/edelmetallKunde/`
    },
    link: {
      LINK_DANKE: "/customerdanke/",
      LINK_KUNDEN_ADDRESSE_MA_EDIT: "/kunde/addresse/edit",
      LINK_KUNDEN_ORDER_DETAILS_MA: "/orderDetailsCustomer/",
      LINK_MITARBEITER_ADD_KUNDEN: "/kunde/daten/edit",
      LINK_KUNDEN_ADDRESSE_MA: "/kunde/addresse/",
      LINK_KUNDENDATEN_EDIT: "/kunde/daten/edit",
      LINK_FILIALELIEFERUNG: "/orderDetailsCustomer/bestelluebersicht",
      LINK_MITARBEITERLOGIN: "/kunde/login",
      LINK_EMPFEHLUNG: "/home/empfehlung/",
      LINK_BACK_TO_SHOP: "/home/kunde/?mandant=",
    },
    string: {
      BUTTON_ORDER: "Zahlungspflichtig bestellen"
    },
    boolean: {
      KUNDEN_SHOP: true
    }
  },
  RageSoBp: {
    context: {
      CONTEXT_ROOT: `/se-shop/sorten/`
    },
    pathes: {
      images: process.env.REACT_APP_IMAGES_SORTEN_URL || "https://www.bayernlb.de/internet/media/se_katalog/seif/so/images_14/currencies/",
      info: ""
    },
    rest: {
      warenkorb: "/sorten/warenkorb/",
      order: "/sorten/warenkorb/order/",
      basedata: "/sorten/katalog",
      catalog: "/sorten/kurs"
    },
    string: {
      SHOP_NAME: "Sorten",
      SHOP_ID: "SKCurrencies"
    }
  },
  RageSoWl: {
    context: {
      CONTEXT_ROOT: `/se-shop/sortenKunde/`
    },
    pathes: {
      images: process.env.REACT_APP_IMAGES_SORTEN_URL || "https://www.bayernlb.de/internet/media/se_katalog/seif/so/images_14/currencies/",
      info: ""
    },
    rest: {
      warenkorb: "/sorten/warenkorb/",
      order: "/sorten/warenkorb/order/",
      basedata: "/sorten/katalog",
      catalog: "/sorten/kurs"
    },
    link: {
      LINK_DANKE: "/customerdanke/",
      LINK_KUNDEN_ADDRESSE_MA_EDIT: "/kunde/addresse/edit",
      LINK_KUNDEN_ORDER_DETAILS_MA: "/orderDetailsCustomer/",
      LINK_MITARBEITER_ADD_KUNDEN: "/kunde/daten/edit",
      LINK_KUNDEN_ADDRESSE_MA: "/kunde/addresse/",
      LINK_KUNDENDATEN_EDIT: "/kunde/daten/edit",
      LINK_FILIALELIEFERUNG: "/orderDetailsCustomer/bestelluebersicht",
      LINK_MITARBEITERLOGIN: "/kunde/login",
      LINK_EMPFEHLUNG: "/home/empfehlung/",
      LINK_BACK_TO_SHOP: "/home/kunde/?mandant=",
    },
    string: {
      BUTTON_ORDER: "Zahlungspflichtig bestellen",
      SHOP_NAME: "Sorten",
      SHOP_ID: "SKCurrencies"
    },
    boolean: {
      KUNDEN_SHOP: true
    }
  },
  VNeoEmBp: {
    context: {
      CONTEXT_ROOT: "../edelmetallShop/",
      CONTEXT_ROOT_SHOP_MA_BUY: "/",
      CONTEXT_ROOT_SHOP_MA_SELL: "/ankauf/",
      CURRENCIES_SHOP_BUY: "../sortenShop/ankauf/",
      CURRENCIES_SHOP_SELL: "../sortenShop/",
      NOBLEMETALS_SHOP_BUY: "../edelmetallShop/ankauf/",
      NOBLEMETALS_SHOP_SELL: "../edelmetallShop/",
      RAGE_ROOT: "../rage",
      REDIRECT_BUY: "ankauf",
      REDIRECT_SELL: "./",
      SHOP_ROOT: ".."
    },
    pathes: {
      images: "$RAGE_ROOT/#{mandantId}/edelmetall/bild/",
      info: "$RAGE_ROOT/edelmetallInfo"
    },
    boolean: {
      VERSE_NEO: true
    },
    Admin: {
      edelmetall: {
        basedata: "/edelmetall/katalog",
        catalog: "/edelmetall/preis",
        appId: "VNeoEmBpBuy",
      },
      sorten: {
        basedata: "/sorten/katalog",
        catalog: "/sorten/kurs",
        appId: "VNeoSoBpBuy",
      },
      // verwendete Host Schnittstellen z.Z. nur bei Auftragsverwaltung wg Unterschiede in VerSEneo und Rage+
      // Release 2.2 nutze vorerst die Rage Api
      //   hostApi: ["SOS279", "SOS280"]
    },
  },
  VNeoEmWl: {
    context: {
      CONTEXT_ROOT: "../edelmetallKunde/",
      RAGE_ROOT: "../rage",
      SHOP_ROOT: ".."
    },
    pathes: {
      images: "$RAGE_ROOT/#{mandantId}/edelmetall/bild/",
      info: "$RAGE_ROOT/edelmetallInfo"
    },
    rest: {
      order: "/edelmetall/warenkorb/orderMitTan/",
    },
    link: {
      LINK_DANKE: "/customerdanke/",
      LINK_KUNDEN_ADDRESSE_MA_EDIT: "/kunde/addresse/edit",
      LINK_KUNDEN_ORDER_DETAILS_MA: "/orderDetailsCustomer/",
      LINK_MITARBEITER_ADD_KUNDEN: "/kunde/daten/edit",
      LINK_KUNDEN_ADDRESSE_MA: "/kunde/addresse/",
      LINK_KUNDENDATEN_EDIT: "/kunde/daten/edit",
      LINK_FILIALELIEFERUNG: "/orderDetailsCustomer/bestelluebersicht",
      LINK_MITARBEITERLOGIN: "/kunde/login",
      LINK_EMPFEHLUNG: "/home/empfehlung/",
      LINK_BACK_TO_SHOP: "/home/kunde/",
      LINK_KUNDE_TAN_AUTH: "/tanAuth",
    },
    string: {
      BUTTON_ORDER: "Zahlungspflichtig bestellen"
    },
    boolean: {
      VERSE_NEO: true,
      KUNDEN_SHOP: true
    }
  },
  VNeoSoBp: {
    context: {
      CONTEXT_ROOT: "../sortenShop/",
      CONTEXT_ROOT_SHOP_MA_BUY: "/",
      CONTEXT_ROOT_SHOP_MA_SELL: "/ankauf/",
      CURRENCIES_SHOP_BUY: "../sortenShop/ankauf/",
      CURRENCIES_SHOP_SELL: "../sortenShop/",
      NOBLEMETALS_SHOP_BUY: "../edelmetallShop/ankauf/",
      NOBLEMETALS_SHOP_SELL: "../edelmetallShop/",
      RAGE_ROOT: "../rage",
      REDIRECT_BUY: "ankauf",
      REDIRECT_SELL: "./",
      SHOP_ROOT: ".."
    },
    pathes: {
      images: "$RAGE_ROOT/#{mandantId}/sorten/bild/",
      info: ""
    },
    rest: {
      warenkorb: "/sorten/warenkorb/",
      order: "/sorten/warenkorb/order/",
      basedata: "/sorten/katalog",
      catalog: "/sorten/kurs"
    },
    string: {
      SHOP_NAME: "Sorten",
      SHOP_ID: "SKCurrencies"
    },
    boolean: {
      VERSE_NEO: true
    },
    Admin: {
      edelmetall: {
        basedata: "/edelmetall/katalog",
        catalog: "/edelmetall/preis",
        appId: "VNeoEmBpBuy",
      },
      sorten: {
        basedata: "/sorten/katalog",
        catalog: "/sorten/kurs",
        appId: "VNeoSoBpBuy",
      },
      // verwendete Host Schnittstellen z.Z. nur bei Auftragsverwaltung wg Unterschiede in VerSEneo und Rage+
      // Release 2.2 nutze vorerst die Rage Api
      //   hostApi: ["SOS279", "SOS280"]
    },
  },
  VNeoSoWl: {
    context: {
      CONTEXT_ROOT: "../sortenKunde/",
      RAGE_ROOT: "../rage",
      SHOP_ROOT: ".."
    },
    pathes: {
      images: "$RAGE_ROOT/#{mandantId}/sorten/bild/",
      info: ""
    },
    rest: {
      warenkorb: "/sorten/warenkorb/",
      order: "/sorten/warenkorb/orderMitTan/",
      basedata: "/sorten/katalog",
      catalog: "/sorten/kurs",
    },
    link: {
      LINK_DANKE: "/customerdanke/",
      LINK_KUNDEN_ADDRESSE_MA_EDIT: "/kunde/addresse/edit",
      LINK_KUNDEN_ORDER_DETAILS_MA: "/orderDetailsCustomer/",
      LINK_MITARBEITER_ADD_KUNDEN: "/kunde/daten/edit",
      LINK_KUNDEN_ADDRESSE_MA: "/kunde/addresse/",
      LINK_KUNDENDATEN_EDIT: "/kunde/daten/edit",
      LINK_FILIALELIEFERUNG: "/orderDetailsCustomer/bestelluebersicht",
      LINK_MITARBEITERLOGIN: "/kunde/login",
      LINK_EMPFEHLUNG: "/home/empfehlung/",
      LINK_BACK_TO_SHOP: "/home/kunde/",
      LINK_KUNDE_TAN_AUTH: "/tanAuth",
    },
    string: {
      BUTTON_ORDER: "Zahlungspflichtig bestellen",
      SHOP_NAME: "Sorten",
      SHOP_ID: "SKCurrencies"
    },
    boolean: {
      VERSE_NEO: true,
      KUNDEN_SHOP: true
    },
    // Release 2.2 nutze vorerst die Rage Api
    // Admin: {
    //   hostApi: ["SOS279", "SOS280"]
    // }
  }
};

export const setup = (shopId) => {
  config.Admin = { ...env.Admin };

  if (process.env.REACT_APP_DEUBA) {
    env.context.SHOP_ROOT = "/deuBa";
    env.context.RAGE_ROOT = "/deuBa/rage";
    env.RageEmWl.context.CONTEXT_ROOT = `/deuBa/edelmetallKunde/`;
    env.RageSoWl.context.CONTEXT_ROOT = `/deuBa/sortenKunde/`;
    env.RageSoBp.context.CONTEXT_ROOT = `/deuBa/sortenShop/`;

    if ("RageSoBp" === shopId) {
      env.RageSoBp.context.CONTEXT_ROOT = "/deuBa/sortenShop/";
      env.RageSoBp.context.CONTEXT_ROOT_SHOP_MA_BUY = "/";
      env.RageSoBp.context.CONTEXT_ROOT_SHOP_MA_SELL = "/ankauf/";
      env.RageSoBp.context.CURRENCIES_SHOP_BUY = "/deuBa/sortenShop/ankauf/";
      env.RageSoBp.context.CURRENCIES_SHOP_SELL = "/deuBa/sortenShop/";
      env.RageSoBp.context.NOBLEMETALS_SHOP_BUY = "/deuBa/edelmetallShop/ankauf/";
      env.RageSoBp.context.NOBLEMETALS_SHOP_SELL = "/deuBa/edelmetallShop/";
      env.RageSoBp.context.RAGE_ROOT = "/deuBa/rage";
      env.RageSoBp.context.REDIRECT_BUY = "ankauf";
      env.RageSoBp.context.REDIRECT_SELL = "./";
      env.RageSoBp.context.SHOP_ROOT = "/deuBa";

      //env.RageSoBp.pathes.images = "$RAGE_ROOT/#{mandantId}/sorten/bild/";
      //env.RageSoBp.pathes.info = "";

      //env.RageSoBp.pathes.rest.warenkorb = "/sorten/warenkorb/";
      //env.RageSoBp.pathes.rest.order = "/sorten/warenkorb/order/";
      //env.RageSoBp.pathes.rest.basedata = "/sorten/katalog";
      //env.RageSoBp.pathes.rest.catalog = "/sorten/kurs";

      env.RageSoBp.string.SHOP_NAME = "Sorten";
      env.RageSoBp.string.SHOP_ID = "SKCurrencies";
    }
  }

  if (env[shopId]) {
    Object.keys(env[shopId]).forEach(key => {
      Object.keys(env[shopId][key]).forEach(setting => {
        env[key][setting] = env[shopId][key][setting];
      });
    });
  }
  // get relative Roots
  ["SHOP_ROOT", "RAGE_ROOT"].forEach(root => {
    if (String(env.context[root]).match(/\.\./)) {
      const currentPath = new URL(window.location.href).pathname.replace(/[^/]*$/, "").replace(/\/{0,2}$/, "/");
      env.context[root] = new URL(window.location.origin + currentPath + env.context[root]).pathname;
    }
    config[root] = env.context[root].replace(/\/{0,2}$/, "");
  });
  // CONTEXT_ROOT ends with one /
  const url = new URL(window.location.href);
  if (env.boolean.VERSE_NEO) {
    config.CONTEXT_ROOT = url.pathname.replace(/[^/]*$/, "").replace(/\/{0,2}$/, "/");
  } else {
    config.CONTEXT_ROOT = String(env.context.CONTEXT_ROOT).trim().replace(/\/{0,2}$/, "/");
  }
  const contextMatch = new RegExp(config.CONTEXT_ROOT, "i");
  // provide relative context for VerseNeo
  Object.keys(env.context).forEach(key => {
    if (["CONTEXT_ROOT", "SHOP_ROOT", "RAGE_ROOT"].includes(key)) return;
    const pathParts = String(config.CONTEXT_ROOT).split("/").filter(x => x);
    config[key] = String(env.context[key]).replace(contextMatch, "/");
    if (!config[key].match(/^\//)) {
      config[key] = "/" + config[key];
    }
    const matchPathParts = config[key].split("/").filter(x => x);
    let partlyMatch = false;
    for (let i = 0, j = 0; i < pathParts.length; i++) {
      if (pathParts[i] === matchPathParts[j]) {
        matchPathParts.shift();
        partlyMatch = true;
        j++;
      } else {
        if (partlyMatch) matchPathParts.unshift("..");
      }
    }
    config[key] = new URL(window.location.origin + config.CONTEXT_ROOT + matchPathParts.join("/")).pathname.replace(/\/{0,3}$/, "/");
  });
  // ankauf LINK_EMPFEHLUNG
  if (url.pathname.match(String(env.context.CONTEXT_ROOT_SHOP_MA_SELL).trim().replace(/\/{0,2}$/, ""))) {
    env.link.LINK_EMPFEHLUNG = (env.context.CONTEXT_ROOT_SHOP_MA_SELL + env.link.LINK_EMPFEHLUNG)
      .trim()
      .replace(/\/{2}/g, "/");
  }
  Object.keys(env.link).forEach(key => {
    try {
      config[key] = new URL(env.link[key]);
    } catch (_e) {
      // replace CONTEXT_ROOT from links
      config[key] = String(env.link[key])
        .trim()
        .replace(contextMatch, "/")
        .replace(/^\/{0,2}/, "/");
      config[key] = new URL(window.location.origin + config[key]).pathname.replace(/\/{0,3}$/, "/");
    }
  });
  config.pathes = {};
  Object.keys(env.pathes).forEach(key => {
    let path = String(env.pathes[key]).trim();
    Object.keys(env.context).forEach(ckey => {
      const match = new RegExp("\\$" + ckey);
      if (path.match(match)) {
        path = path.replace(match, config[ckey]).replace(/\/{2,3}/, "/");
      }
    });
    config.pathes[key] = path;
  });
  config.rest = {};
  Object.keys(env.rest).forEach(key => {
    config.rest[key] = String(env.rest[key]).trim();
  });
  config.servlet = {};
  Object.keys(env.servlet).forEach(key => {
    config.servlet[key] = String(env.servlet[key]).trim();
  });
  Object.keys(env.string).forEach(key => {
    config[key] = String(env.string[key]).trim();
  });
  Object.keys(env.number).forEach(key => {
    config[key] = Number(env.number[key]) || 0;
  });
  Object.keys(env.boolean).forEach(key => {
    config[key] = !!String(env.boolean[key]).trim().match(/^(true|yes|on)$/i);
  });
  config.Admin = { ...config.Admin, ...env.Admin };
  config.MITARBEITER_SHOP = !config.KUNDEN_SHOP;
};

// compute shop dynamicly if not set in .env
export const getShopId = () => {

  if (process.env.REACT_APP_APPLICATION_ID_BASE) {
    return String(process.env.REACT_APP_APPLICATION_ID_BASE);
  }

  if (process.env.REACT_APP_APPLICATION_ID && process.env.NODE_ENV !== "test") {
    return String(process.env.REACT_APP_APPLICATION_ID).slice(0, 8);
  }
  let shopId = "RageEmBp";
  if (window.location.pathname.match("/se-shop/sortenKunde/") ||
    window.location.pathname.match("/deuBa/sortenKunde/")) {
    shopId = "RageSoWl";
    config.KUNDEN_SHOP = true;
  } else if (window.location.pathname.match("/sortenKunde/")) {
    shopId = "VNeoSoWl";
    config.KUNDEN_SHOP = true;
  } else if (window.location.pathname.match("/se-shop/edelmetallKunde/") ||
    window.location.pathname.match("/deuBa/edelmetallKunde/")) {
    shopId = "RageEmWl";
    config.KUNDEN_SHOP = true;
  } else if (window.location.pathname.match("/edelmetallKunde/")) {
    shopId = "VNeoEmWl";
    config.KUNDEN_SHOP = true;
  } else if (window.location.pathname.match("/deuBa/sortenShop/")) {
    shopId = "RageSoBp";
  } else if (window.location.pathname.match("/sortenShop/")) {
    shopId = "VNeoSoBp";
  } else if (window.location.pathname.match("/sorten/")) {
    shopId = "RageSoBp";
  } else if (window.location.pathname.match("/deuBa/edelmetallShop/")) {
    shopId = "RageEmBp";
  } else if (window.location.pathname.match("/edelmetallShop/")) {
    shopId = "VNeoEmBp";
  }
  return shopId;
};

config.init = () => {
  let shopId = getShopId();
  config.applicationId = `${shopId}Buy`;
  config.applicationIdAnkauf = `${shopId}Sell`;
  setup(shopId);
};
config.init();
export default config;
